module.exports = __webpack_public_path__ + "img/Conduce2.0b504e43.png";